export InquiryForm from './InquiryForm';



// WEBPACK FOOTER //
// /src/components/Inquiry/index.js